<template>
  <tr>
    <td
      class="body-sm p-2"
      v-text="license.license_type"
    />
    <td
      class="body-sm p-2"
      v-text="license.license_number"
    />
    <td
      class="body-sm p-2"
      v-text="license.license_state"
    />
    <td class="body-sm flex items-center gap-4 p-2">
      <button
        :disabled="isLoading"
        class="wc-focus font-semibold text-primary-500  hover:underline hover:underline-offset-1"
        data-test-id="edit-license-button"
        type="button"
        @click="$emit('editLicense', license)"
      >
        <span v-text="'Edit'" />
        <span
          class="sr-only"
          v-text="`License ${license.license_number}`"
        />
      </button>

      <button
        :disabled="isLoading"
        class="wc-focus font-semibold text-primary-500  hover:underline hover:underline-offset-1"
        data-test-id="delete-license-button"
        type="button"
        @click="handleDeleteLicense"
      >
        <span v-text="'Delete'" />
        <span
          class="sr-only"
          v-text="`License ${license.license_number}`"
        />
      </button>
    </td>
  </tr>
</template>

<script lang="ts" setup>
import { ref } from 'vue'

import { log } from '@js/utils/logger'
import { deleteCustomerLicense } from '@js/api/customer/deleteCustomerLicense'

import { CustomerLicense } from '@js/api/types/customer/CustomerLicense'

defineOptions({
  name: 'EditLicenseTableRow',
})

const props = defineProps<{
  customerId: number
  license: CustomerLicense
}>()

const emit = defineEmits<{
  licenseDeleted: [licenseId: number]
  editLicense: [license: CustomerLicense]
}>()

const isLoading = ref(false)

const handleDeleteLicense = async (): Promise<void> => {
  try {
    isLoading.value = true

    const deletedLicense = await deleteCustomerLicense({
      customerId: props.customerId,
      licenseId: props.license.license_id,
    })

    emit('licenseDeleted', deletedLicense.license_id)
  } catch (error) {
    log({
      message: 'Delete License Error',
      file: 'src/wcei/js/components/account/profile/EditLicenseTableRow.vue',
    })
  } finally {
    isLoading.value = false
  }
}
</script>
